import { LoadingController, ToastController, NavController, ModalController } from '@ionic/angular';
import { Component, OnInit } from '@angular/core';
import { AlertService } from '../components/alert';
import { UsuarioApiService } from '../api/usuario-api.service';

@Component({
  selector: 'app-recuperacao-senha',
  templateUrl: './recuperacao-senha.page.html',
  styleUrls: ['./recuperacao-senha.page.scss'],
})
export class RecuperacaoSenhaPage implements OnInit {

  edtEmail: string;
  constructor(
    public navCtrl: NavController,
    private alertService: AlertService,
    public loadingController: LoadingController,
    public toastController: ToastController,
    private modalController: ModalController,
    public api: UsuarioApiService) { }

  ngOnInit() {

  }

  async recuperarSenha() {
    const loading = await this.loadingController.create({
      message: 'Aguarde...',
      duration: 10000
    });
    await loading.present();

    this.api.recuperarSenha(this.edtEmail)
      .subscribe(res => {
        loading.dismiss();
        if (res.message != null) {
          this.alertService.sucesso(res.message);
        }
        alert('Será enviado um e-mail com as instruções de troca de senha!');
        this.closeModal();
      }, err => {
        this.alertService.erro(err);
      }
      );
  }

  closeModal() {
    this.modalController.dismiss();
  }
}
